import { render, staticRenderFns } from "./summary-airport.vue?vue&type=template&id=7c5e4015&scoped=true"
import script from "./summary-airport.vue?vue&type=script&lang=ts"
export * from "./summary-airport.vue?vue&type=script&lang=ts"
import style0 from "./summary-airport.vue?vue&type=style&index=0&id=7c5e4015&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5e4015",
  null
  
)

export default component.exports